// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1Lezt","notes":"Notes_notes__2xQCJ"};